import 'foundation-sites'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { Getters, Mutations } from '../../store/manager/helpers'
import { ArticleData, ModalState, SiteUrlModel } from '../../store/manager/state'
import { ArticleDetailUrlFactory } from '../../misc/generate-url'

@Component({
  props: {
    val: {
      type: Object, /* ArticleData */
      required: true
    },
    id: {
      type: String,
      required: true
    }
  }
})
export default class ArticleMenu extends Vue {
  $store: Store<RootState>
  readonly val: ArticleData
  readonly id: string

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  siteUrlEvent(): void {
    const kajikiList = Getters.kajikiList(this.$store)
    const kajiki = kajikiList.find(kajiki => kajiki.kajikiId === this.siteId)
    const category = this.val.category
    const data = {
      categoryId: category.categoryId,
      categoryName: category.categoryName,
      contentId: this.val.contentId,
      status: this.val.status,
      protocol: kajiki.protocol,
      domain: kajiki.domain,
      isPublished: kajiki.isPublished,
      contentDetailPrefixPath: kajiki.contentDetailPrefixPath
    }

    const modalState: SiteUrlModel = new ArticleDetailUrlFactory('get-site-url', data).create()
    Mutations.setUrlModalState(this.$store, modalState)
    this.$emit('menu-selected', 'get-site-url')
  }

  articleCopyEvent(): void {
    const modalState: ModalState = {
      modalName: 'article-copy',
      data: this.val
    }
    Mutations.setModalState(this.$store, modalState)
    this.$emit('menu-selected')
  }

  articleConfigEvent(): void {
    const modalState: ModalState = {
      modalName: 'publish-config',
      data: this.val
    }
    Mutations.setModalState(this.$store, modalState)
    this.$emit('menu-selected')
  }

  articleDeleteEvent(): void {
    const modalState: ModalState = {
      modalName: 'article-delete',
      data: this.val
    }
    Mutations.setModalState(this.$store, modalState)
    this.$emit('menu-selected')
  }
}
